import http from "../http-common";

// 区分値情報を取得する。
const jyua101 = grpid => {
    return http.get(`/jyu/jyua101?grpid=${grpid}`, { withCredentials: true });
};

// 得意先注文画面の初期表示情報を取得する。
const jyua102 = (dateFrom, dateTo, dnpyono, mode, seizoymd) => {
    const params = {
        procMode: mode,
        dateFrom: dateFrom,
        dateTo: dateTo,
        dnpyono: dnpyono,
        seizoymd: seizoymd
    }
    return http.get(`/jyu/jyua102`, {
        params: params,
        withCredentials: true
    });
};

// 公開DBに得意先注文情報を保存する。
const jyua103 = data => {
    return http.post(`/jyu/jyua103`, data, { withCredentials: true });
};

// 注文一覧情報を取得する。
const jyua104 = params => {
    return http.get(`/jyu/jyua104`, {
        withCredentials: true,
        params: params
    });
};

// 備考ﾏｽﾀ情報を取得する。
const jyua106 = id => {
    return http.get(`/jyu/jyua106?gmnid=${id}`, { withCredentials: true });
};

// Presenter の API を呼び出して、ユーザーとパスワードの情報を登録します。
const jyua107 = data => {
    return http.post(`/jyu/jyua107`, data, { withCredentials: true })
};

const jyua108 = dnpyoNo => {
    return http.get(`/jyu/jyua108?dnpyono=${dnpyoNo}`, { withCredentials: true });
};

const jyuService = {
    jyua101,
    jyua102,
    jyua103,
    jyua104,
    jyua106,
    jyua107,
    jyua108
};

export default jyuService;
